module.exports = __webpack_public_path__ + "static/media/whatsapp.5446d6d9.svg";